module.exports = __webpack_public_path__ + "static/media/399100ce-4c9f-4212-a0d0-c9d7f4375894.7ef7a766.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/399100ce-4c9f-4212-a0d0-c9d7f4375894.jpg
// module id = 814
// module chunks = 0